
import { defineComponent } from "vue";

import OrderCommentCatalogue from "@/components/catalogues/OrderCommentCatalogue/OrderCommentCatalogue.vue";

export default defineComponent({
  components: { OrderCommentCatalogue },
  props: {},
  methods: {},
  data() {
    return {};
  },
});
